/* DW Social Proof — polaroid lightbox.
   Progressive enhancement: the polaroids are real <button>s with their data on
   them; this script opens the shared lightbox on click. If JS fails, the photos
   still ticker and show their short quote — nothing breaks.
   Guarded so multiple section instances don't double-bind. */
(function () {
  'use strict';
  if (window.__dwSocialProofInit) return;
  window.__dwSocialProofInit = true;

  var lightbox, imgEl, starsEl, quoteEl, nameEl, detailEl, linkEl, linkLabelEl;
  var lastFocused = null;
  var htmlEl = document.documentElement;

  function cacheNodes() {
    lightbox = document.querySelector('[data-dw-social-lightbox]');
    if (!lightbox) return false;
    imgEl = lightbox.querySelector('[data-dw-lb-img]');
    starsEl = lightbox.querySelector('[data-dw-lb-stars]');
    quoteEl = lightbox.querySelector('[data-dw-lb-quote]');
    nameEl = lightbox.querySelector('[data-dw-lb-name]');
    detailEl = lightbox.querySelector('[data-dw-lb-detail]');
    linkEl = lightbox.querySelector('[data-dw-lb-link]');
    linkLabelEl = lightbox.querySelector('[data-dw-lb-link-label]');
    return true;
  }

  function starsMarkup(rating) {
    var r = parseInt(rating, 10) || 0;
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out +=
        '<span class="dw-pol__star' +
        (i <= r ? ' is-filled' : '') +
        '"><svg class="dw-icon dw-icon--sm dw-icon--star" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" focusable="false">' +
        '<path d="M229.06,108.79l-48.7,42,14.88,62.79a8.4,8.4,0,0,1-12.52,9.17L128,189.09,73.28,222.74a8.4,8.4,0,0,1-12.52-9.17l14.88-62.79-48.7-42A8.46,8.46,0,0,1,31.73,94L95.64,88.8l24.62-59.6a8.36,8.36,0,0,1,15.48,0l24.62,59.6L224.27,94A8.46,8.46,0,0,1,229.06,108.79Z" opacity="0.2"/>' +
        '<path d="M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z"/></svg></span>';
    }
    return out;
  }

  function openFrom(btn) {
    if (!lightbox && !cacheNodes()) return;

    var fullNode = btn.querySelector('.dw-pol__full');
    var fullText = fullNode ? fullNode.innerHTML : '';
    if (!fullText) {
      var q = btn.querySelector('.dw-pol__quote');
      fullText = q ? q.textContent : '';
    }

    imgEl.src = btn.getAttribute('data-img') || '';
    imgEl.alt = btn.getAttribute('data-name') || 'Customer photo';
    starsEl.innerHTML = starsMarkup(btn.getAttribute('data-rating'));
    quoteEl.innerHTML = fullText;
    nameEl.textContent = btn.getAttribute('data-name') || '';
    detailEl.textContent = btn.getAttribute('data-detail') || '';

    var link = btn.getAttribute('data-link');
    if (link) {
      linkEl.href = link;
      if (linkLabelEl) linkLabelEl.textContent = btn.getAttribute('data-link-label') || 'Shop this product';
      linkEl.hidden = false;
    } else {
      linkEl.hidden = true;
    }

    lastFocused = btn;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    htmlEl.style.overflow = 'hidden';
    var closeBtn = lightbox.querySelector('.dw-social-lightbox__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 40);
  }

  function close() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    htmlEl.style.overflow = '';
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    lastFocused = null;
  }

  // Delegated open — works for every section instance and survives editor re-renders.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dw-pol]');
    if (btn) {
      e.preventDefault();
      openFrom(btn);
      return;
    }
    if (e.target.closest('[data-dw-social-close]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && lightbox.classList.contains('is-open')) close();
  });
})();
